<template>
  <div class="payments-page">
    <div class="content-panel">
      <img
        class="aspire-logo"
        src="@/components/AppMenu/img/aspire-logo.svg"
        alt="Aspire-Logo-Large"
      />
      <div class="aspire-desc">Payements feature is not available for now</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InterviewPayements",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
</style>